import { SplOriginAlias, SplOriginEnvironment } from '@splitory/splitory-environment';

export const splOriginEnvironment: SplOriginEnvironment = {
  originAlias: SplOriginAlias.client,
};
